import QrCodeStore from "./QRCode/QRCodeStore";

const inventoryAndFieldStoreList = [
    { name: "qrCodeStore", store: QrCodeStore },
];

// Removed precast-specific stores:
// - IFCTrackerStore - IFC/BIM tracking for panels
// - HardwareOverviewScheduleStore - Hardware for panel installation
// - PanelYardManagementStore - Panel yard management

export default inventoryAndFieldStoreList;
